import type { ComponentType } from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import { Button } from './ui/button.js';
import { Card } from './ui/card.js';

// Compact action card that sits beside a page title — a short label, a
// line of explanation, and one button. Used for the proptree settings
// entry points and the marketing actions, so they read as the same
// family of controls.
export function SettingsCard({
  title,
  subtitle,
  onAction,
  actionLabel = 'Settings',
  icon: Icon = SettingsIcon,
  disabled = false,
}: {
  title: string;
  subtitle: string;
  onAction: () => void;
  /** Button text. Defaults to "Settings" for the proptree entry points. */
  actionLabel?: string;
  /** Button glyph. Defaults to the gear. */
  icon?: ComponentType<{ className?: string }>;
  disabled?: boolean;
}) {
  return (
    <Card className="flex w-[300px] items-center gap-3 px-4 py-3">
      <div className="min-w-0 flex-1">
        <div className="font-sans text-[13px] font-semibold leading-tight text-foreground">
          {title}
        </div>
        <p className="mt-1 font-sans text-[11px] leading-snug text-muted-foreground">
          {subtitle}
        </p>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={onAction}
        disabled={disabled}
        className="shrink-0"
      >
        <Icon />
        {actionLabel}
      </Button>
    </Card>
  );
}
